import { create } from "zustand";

const components = ["intro", "create", "deployments", "docs"];

export const usePageController = create((set) => ({
  currentComponent: "",
  setCurrentComponent: (component) => set({ currentComponent: component }),
}));
